// extracted by mini-css-extract-plugin
module.exports = {"item":"RecordItem_item_1Oesd","button":"RecordItem_button_1TnPn"};